import React from 'react';
import { Link, LinkProps, NavLink, NavLinkProps } from 'react-router-dom';
import { useQueryToken } from './LocalAuthWrapper';

export function LinkWithToken(props: LinkProps) {
  const token = useQueryToken();

  return (
    <Link {...props} to={props.to + (token ? `?token=${token}` : '')}>
      {props.children}
    </Link>
  );
}

export function NavLinkWithToken(props: NavLinkProps) {
  const token = useQueryToken();

  return (
    <NavLink {...props} to={props.to + (token ? `?token=${token}` : '')}>
      {props.children}
    </NavLink>
  );
}
